import { OrbitControls } from "@react-three/drei";

import { HamiltonianOperator, Particle } from "../../components/three";
import { Renderer } from "../../components";

import classes from "./Test.module.scss";
export default function TestPage(props) {
  const resolution = 60;

  return (
    <div className={classes.test}>
      <Renderer
        cameraDistance={resolution / 10}
        objects={
          <>
            <OrbitControls />
            <HamiltonianOperator resolution={resolution} extent={4}>
              <Particle />
            </HamiltonianOperator>
          </>
        }
      />
    </div>
  );
}
